import React from 'react'
import { TableCell, TableRow } from '@mui/material'
import { formatDateYYYYMMDD } from '../../../../packages/utils/numberFormatters'

interface GenericHistoryTableRowProps {
    date: string
    content: string
    locale: string
    symbol?: string
    multipleInstrumentsExists?: boolean
    isSmallScreen: boolean
}

export const GenericHistoryTableRow = ({
    date,
    content,
    locale,
    symbol = undefined,
    multipleInstrumentsExists = false,
    isSmallScreen,
}: GenericHistoryTableRowProps) => {
    return (
        <TableRow>
            <TableCell>{formatDateYYYYMMDD(date, { locale })}</TableCell>
            {multipleInstrumentsExists && !isSmallScreen ? <TableCell>{symbol}</TableCell> : null}
            <TableCell>{content}</TableCell>
            {!isSmallScreen ? (
                <>
                    <TableCell />
                    <TableCell />
                </>
            ) : null}
            <TableCell />
        </TableRow>
    )
}
